export default defineNuxtRouteMiddleware(() => {
  const { data } = useAuth();
  const $auth = data.value;

  if (!Boolean($auth?.approved)) {
    return navigateTo('/');
  }
});
